<template>
    <div class="main_container">
        <div class="layout_split">
            <RightWing :index="3" :score="score" />

            <div class="main_area">
                <div style="opacity:0; font-size:10px;">space</div>
                <div class="section_title_container">
                    <div class="section_title">{{sectionTitle}}</div>
                    <div class="article_title">"{{articleTitle}}"</div>
                </div>
                <div class="article_title_mobile">{{articleTitle}}</div>

                <div class="guide_text">
                    이 주제는 사실일까요? 판정보류일까요? 거짓일까요?<br>선택해주세요.
                </div>

                <div class="flex_list">
                    <div v-for="btn in buttons" :key="btn.idx"
                            :class="[btn.bg, btn.active ? btn.bgActive : '']" class="flex_item"
                            @click="touchButton(btn.idx)">
                        {{btn.text}}
                    </div>
                </div>

                <div class="btn_container">
                    <div class="btn_ok" :class="buttonOkClass" @click="next">확인하기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'

export default {
    name: 'SelectTrueOrNotView',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            score: null,
            buttons: [
                {idx: 0, text: '사실이다', bg: 'bg_true', bgActive: 'active_true', active: false},
                {idx: 1, text: '판정보류', bg: 'bg_undecided', bgActive: 'active_undecided', active: false},
                {idx: 2, text: '거짓이다', bg: 'bg_false', bgActive: 'active_false', active: false},
            ],
            sectionTitle: null,
            articleTitle: null,
            result: null,
            buttonOkClass: 'btn_ok_inactive',
            
        }
    },

    mounted() {
        const currentPlay = this.$getCurrentGame()
        const selectedArticleData = this.$gameData.sections[currentPlay.selectedSection].articles[currentPlay.selectedArticle]
        this.sectionTitle = this.$gameData.sections[currentPlay.selectedSection].title
        this.articleTitle = selectedArticleData.title
        this.score = currentPlay.score

        // TODO 현재 플레이 아티클 찾기 위로 올리기 (이거 무슨 생각을 했던 걸까?)

        // 판정을 다시 하는걸 막는다
        for(let article of currentPlay.articles) {
            if(article.title == this.articleTitle) {
                // 이미 판정함
                if(article.playerResult != undefined) {
                    this.$router.push('/judgement')
                }
                break;
            }
        }
    },

    methods: {
        next: function() {
            if(this.result == null) {
                return
            }

            //TODO getCurrentGame -> getCurrentPlay
            let currentPlay = this.$getCurrentGame()
            for(let article of currentPlay.articles) {
                if(article.title == this.articleTitle) {
                    article.playerResult = this.result
                    break;
                }
            }
            this.$setCurrentGame(currentPlay)
            
            this.$router.push('/judgement')
        },

        touchButton: function(idx) {
            for(let btn of this.buttons) {
                if(btn.idx == idx) {
                    btn.active = true
                    this.result = btn.idx
                    this.buttonOkClass = 'btn_ok_active'
                }
                else {
                    btn.active = false
                }
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn_ok {
    text-align: center;
    width: 280px;
    padding: 10px;
    margin: 0px 10px;
    border: 2px solid black;
    font-weight: 700;
    font-size: 26px;
    color: black;
    cursor: pointer;
}
.btn_ok_active {
    box-shadow:3px 3px 3px grey;
    background-color: white;
}
.btn_ok_inactive {
    background-color: gray;
}
.btn_container {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}




/* pc */
@media screen and (min-width: 415px) {
    .flex_item {
        width: 250px;
        height: 250px;
        text-align: center;
        box-shadow:3px 3px 3px grey;
        font-size: 40px;
        font-weight: 700;
        line-height: 250px;
        border: 2px black solid;
        background-color: white;
        cursor:pointer;
    }
    .bg_true {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_true.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 250px 250px;
    }
    .bg_undecided {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_undecided.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 250px 250px;
    }
    .bg_false {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_false.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 250px 250px;
    }
    .layout_split {
        display:flex;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display:flex;
        margin-left:20px;
    }
    .article_title_mobile {
        display: none;
    }
    .flex_list {
        display:flex;
        margin:10px 90px;
        justify-content:space-between;
    }
    .guide_text {
        text-align:center;
        margin:20px;
        font-size:20px;
    }
}

/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display: none;
    }
    .article_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
        /* border-bottom: solid black 1px; */
        text-decoration: underline;
    }
    .flex_list {
        display:flex;
        flex-direction: column;
        margin: 20px 0px;
    }
    .flex_item {
        padding: 10px;
        text-align: center;
        box-shadow: 2px 2px 2px grey;
        font-size: 30px;
        font-weight: 700;
        margin: 5px 20px;
        height: 100px;
        background-color: white;
        border-radius: 5px;
    }
    .bg_true {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_true_mobile.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 330px 100px;
    }
    .bg_undecided {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_undecided_mobile.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 330px 100px;
    }
    .bg_false {
        background-repeat: no-repeat;
        background-image: url("../assets/img/btn_false_mobile.png");
        /* 첫 번째 값: 이미지 너비, 두 번째 값: 이미지 높이 */
        background-size: 330px 100px;
    }
    .guide_text {
        display: none;
    }
}

.active_true {
    background-color: #64ACF8;
}
.active_undecided {
    background-color: #FFF73E;
}
.active_false {
    background-color: #ED5750;
}

</style>
